
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexrmz6c8Adq5JXGznq9ttvS0P4o_453TX1HPUvrZ0mEpMz8Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/index.vue?macro=true";
import { default as indexqv_iKp1jlJ_45fDL_VWCqwr4kCRBpLbsOSkebsXdWK_IoMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/login/index.vue?macro=true";
import { default as indexLKzQPIpHzaoa2ZGROGL9zOtNthB6QVoVb_REifjLOjIMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/aanbod/index.vue?macro=true";
import { default as indexvLYw9Wkv_xw_45bfcBylEKrnhjsOqZ2UFSMBOCSl_45tAikMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/afspraak/index.vue?macro=true";
import { default as _91token_93Nm_45RdFMV3_45chtlHaLnKoWb3U_1Vl67GLGryU3FMwHM8Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onfido/[token].vue?macro=true";
import { default as _91hash_93NHU4fWCLoEHMhGnyXEbHb9E45R1DlXiMzBQ9ViwrYhAMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/payment/[hash].vue?macro=true";
import { default as _91hash_93owWnVqIAW4xZdcyyiaJBLQiqLafVtYEHGQx714TwRa0Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/passeren/[hash].vue?macro=true";
import { default as indexZUWDeHx6XTZ_5SCycW67pX2S9elvshYVe03NScEy75YMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/hypotheken/index.vue?macro=true";
import { default as _91id_93FWVa5K51WYAXg_NDMQ9Bm9p67l_sBo2w_45imeHuCB1UYMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[token]/[id].vue?macro=true";
import { default as _91slug_93OxjnhBBUxWVs2T25qtU02oEXaavPHmHz6Z5Rm7mmzA0Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/[slug].vue?macro=true";
import { default as indexPY5Ue6mOHX7puT2Gn2A5QPveC3BkddKaFyYF46XlMIsMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[token]/index.vue?macro=true";
import { default as indexQ_OKEngpitaFqWaa_3UjyZ1YIIQSuxrATEGSirXBBB4Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/instellingen/index.vue?macro=true";
import { default as indexDsKVJbblEalVDWX1GiY3XD0kRJkXu6apXwMG41xOfx4Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/index.vue?macro=true";
import { default as errorEJUW_YqSUd2dWsYmb2CSw8oxOc_OUg4NI5tZOlRNmSMMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/error.vue?macro=true";
import { default as indexgP3UFOSaXwVNokB6GPV2LHbcGqT2807J_5d7Ko_45e4IwMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/index.vue?macro=true";
import { default as indexZF_45hzXm_n1QMWbJbOius6_32KZGXeQrQta4Lnp8TgfcMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/investeringen/index.vue?macro=true";
import { default as qrcode1X3kcNZPy6Neuwg_ZbWy_KjGCU5M94GfJ3TCuyTy4ecMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/qrcode.vue?macro=true";
import { default as succes21H9Ea_eSmgZmA6j8CTCnMUXHdSglOzusXucMtTxUhwMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/succes.vue?macro=true";
import { default as aanvraag6oDt_x3W_45Wvu3rpX_456WeSQrQwVTQmieE0c8ZqJAL_450UMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/aanvraag.vue?macro=true";
import { default as index9UeF6qNZK_2KiPjDX_OyWqH6xsx08gXMSxv608DIs0EMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-aanvragen/index.vue?macro=true";
import { default as indexOxZ7pVgAcLfkeojZnWSB1KOku8j_AqLN14hxlH666csMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/index.vue?macro=true";
import { default as _91hash_93kuB_sBRMJk432ULAgx_sccaSROEmZ9L_45eRoSdcUGXcYMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/rentevoorstel/[hash].vue?macro=true";
import { default as _91hash_93rxnRMmL_jkY1xZZ9fCTzMiZ838ldBXyIi5iM7seMffMMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/verzekeringen/[hash].vue?macro=true";
import { default as indexkkghDehtdqCKtaMYjrUs4cJjoTSqWKy3iDi_45Xc3VK6EMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/afspraak/[hash]/index.vue?macro=true";
import { default as indexCAiXGVCSEEemE0LbiuEXo1KTwZAryU1HzV4wmpaka78Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/feedback/[hash]/index.vue?macro=true";
import { default as indexA3irFoClL80EIeNJYyufg0PGrPNfaPoELJEVdBChH2wMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/hypotheken/[id]/index.vue?macro=true";
import { default as indexDJHqnrynt7fANN2roPWAYvDd6wn37SaN1KcfzJcehWAMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/claims-en-opties/index.vue?macro=true";
import { default as reset_45wachtwoordXnUNi_584dftXlZ0QIyhft_j_KIBKPxBQa_QjsUsneQMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/login/reset-wachtwoord.vue?macro=true";
import { default as index65drtMA_hGjHMVx1XmFrm5ISYM2XCj5h_8TcbAQlBV8Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-partnerplan/index.vue?macro=true";
import { default as index5AX_45bch5_45UEItFcjR3_4599y74MeARNg2AvzvdA5758EAMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-organisaties/index.vue?macro=true";
import { default as index0g72Aq9fgwbNHkHKu5nYNDIqEJdeFiPi_45mSPmuMwsvMMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/investeringen/[id]/index.vue?macro=true";
import { default as indexvEKi6T2eGeka3VkPjMyicp8oKkLauSjLqnGJpI_Lma8Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/privacy-verklaring/index.vue?macro=true";
import { default as indexOfBgwnEanQrjvymHPYGKIL6LkdkMOv357nkMDM1rVLsMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/hypotheek-overzicht/index.vue?macro=true";
import { default as wachtwoord_45vergetenJEVDwRHcjIaJmBe1RKxDOL9xttJ46S68pJcP21xL0xsMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/login/wachtwoord-vergeten.vue?macro=true";
import { default as index95r4dhDM4FksnyyKW5kMsavt0vttW9O26BM1rNuuY_AMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/index.vue?macro=true";
import { default as indexyEIIhle5L948T1FsK5lcsHksaaEyH_45YFdwol_jzbOFIMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/financieel-overzicht/index.vue?macro=true";
import { default as _91hash_93Tx5y8wiAS_wdr_45tWozNDZ3LN5QtdSMOC6RTKPdjoPrwMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/einde-looptijd-lening/[hash].vue?macro=true";
import { default as _91fundKey_93JRHeWOvLFO2haEf4_ooCJ1KZzDTy8DzDoMwyhL4AjvAMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[exchangeToken]/[fundKey].vue?macro=true";
import { default as indexXyPtcMmdgU00M_wSDv3_45NdP573J9JOySC24vzfFBJzMMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/naw-gegevens/index.vue?macro=true";
import { default as _91token_937Y4OtMVbIp7n37zGerfFyzth7vFq7gZXLVYUiuMoD5sMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/[signing_id]/[token].vue?macro=true";
import { default as _91experience_93ASjcrE8H6_viUi9q_45JJ4WPijjtb6UbdRyfLBxgYrSqkMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/bedankt/[experience].vue?macro=true";
import { default as index3QB4pyKtEC1X6znjHH1Qh_elYOhsDVTgBilJk5tJko4Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/financieel-overzicht/rente/index.vue?macro=true";
import { default as indexViZFAeztq0Il_451ebMujwKtC9ohVZwH5tplt2OAJDldcMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/iban-overzicht/index.vue?macro=true";
import { default as indexNPDnIlC9ckPlvmZwiVy_45i8itPKw3gTufpRDLamreo_45EMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-aanvragen/[offerNumber]/index.vue?macro=true";
import { default as indexTfcv3ddizxUFHaUoiBB_ZpNfgwvDib4w9SMhInW6xf4Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/deelname/index.vue?macro=true";
import { default as indexcqzil15MDKR2CiTRF9JwSLGdX1rMv3dezW_45BfwnLheAMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/overmaken/index.vue?macro=true";
import { default as indexciqzk_45Yo_7SujsjG6YJWJmmQ7bCVE2oN52XBZZ_y24oMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/financieel-overzicht/financien/index.vue?macro=true";
import { default as indexOtjefEugoDP3zrrxKJ5HerrqDSa3GqS9FRKinyC7o8EMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/documenten/index.vue?macro=true";
import { default as indexwnNrciLxZkRwD2ywuuNhJX1Q0iO20ye5sh45PYNQ_45SMMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[exchangeToken]/onboarding/index.vue?macro=true";
import { default as indexuilgMJ9uiCGnch8rNmNHnbcjN3sqz45vqSUUZbDyvagMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/inschrijving/index.vue?macro=true";
import { default as indexCJUTB51XTDd8ZmBkmMLqTGDvWw4qSeNXMDoe39dF5UEMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/ondertekenen/index.vue?macro=true";
import { default as indexM_45K36VKiFvI91_45rlwCcAhnUcUMb1Wl2FeaFI4_45k4vZMMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-partnerplan/[token]/[choice]/index.vue?macro=true";
import { default as aanvraagbZXrsccX9OLehDf1bezxS2lQlXBvZd_45cTj93cCp7N14Meta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[exchangeToken]/onboarding/aanvraag.vue?macro=true";
import { default as _91choice_93jnOyCGGTM_yaTnkdma_459dp5_Ly2o33U4vaxEFf6mYcgMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/aanbod-optie/[propertyId]/[hash]/[choice].vue?macro=true";
import { default as indexpOSyu6Pdf44emTo6XhNLxfpl_45CTZsDh49HnoZu8ZISwMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-organisaties/bedrijfs-gegevens/index.vue?macro=true";
import { default as indexSl2nwE_45Py0jtcI9dA0vCeB8ttkwgHLS69hL8Sv4S2joMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/digitaal-identificeren/index.vue?macro=true";
import { default as indexg7MSwW9USkg2nxltiIz6AFy_Rwjjxixq2fFCUDlMDYkMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-aanvragen/[offerNumber]/herkomst/index.vue?macro=true";
import { default as indexilzQLt_vHYFmt1xJiguUoPSGiurMo0kXr5nzjDn_L8oMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/fonds-optie/[property_id]/[hash]/[type]/index.vue?macro=true";
import { default as indexIjpNBLEbRRgWoJIWDx_u1smQy3YsQ50H5V9PaCJ0LAoMeta } from "/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-organisaties/[companyId]/iban-overzicht/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexrmz6c8Adq5JXGznq9ttvS0P4o_453TX1HPUvrZ0mEpMz8Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexqv_iKp1jlJ_45fDL_VWCqwr4kCRBpLbsOSkebsXdWK_IoMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/login/index.vue")
  },
  {
    name: "aanbod",
    path: "/aanbod",
    meta: indexLKzQPIpHzaoa2ZGROGL9zOtNthB6QVoVb_REifjLOjIMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/aanbod/index.vue")
  },
  {
    name: "Afspraak maken",
    path: "/afspraak",
    meta: { ...(indexvLYw9Wkv_xw_45bfcBylEKrnhjsOqZ2UFSMBOCSl_45tAikMeta || {}), ...{"middleware":["auth","investor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/afspraak/index.vue")
  },
  {
    name: "onfido-token",
    path: "/onfido/:token()",
    meta: _91token_93Nm_45RdFMV3_45chtlHaLnKoWb3U_1Vl67GLGryU3FMwHM8Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onfido/[token].vue")
  },
  {
    name: "payment-hash",
    path: "/payment/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/payment/[hash].vue")
  },
  {
    name: "passeren-hash",
    path: "/passeren/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/passeren/[hash].vue")
  },
  {
    name: "borrowerInvestments",
    path: "/hypotheken",
    meta: { ...(indexZUWDeHx6XTZ_5SCycW67pX2S9elvshYVe03NScEy75YMeta || {}), ...{"middleware":["auth","avborrower","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/hypotheken/index.vue")
  },
  {
    name: "sso-token-id",
    path: "/sso/:token()/:id()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[token]/[id].vue")
  },
  {
    name: "onboarding-slug",
    path: "/onboarding/:slug()",
    meta: { ...(_91slug_93OxjnhBBUxWVs2T25qtU02oEXaavPHmHz6Z5Rm7mmzA0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/[slug].vue")
  },
  {
    name: "sso-token",
    path: "/sso/:token()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[token]/index.vue")
  },
  {
    name: "instellingen",
    path: "/instellingen",
    meta: { ...(indexQ_OKEngpitaFqWaa_3UjyZ1YIIQSuxrATEGSirXBBB4Meta || {}), ...{"middleware":["auth","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/instellingen/index.vue")
  },
  {
    name: "mijn-profiel",
    path: "/mijn-profiel",
    meta: { ...(indexDsKVJbblEalVDWX1GiY3XD0kRJkXu6apXwMG41xOfx4Meta || {}), ...{"middleware":["auth","investor"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/index.vue")
  },
  {
    name: "ockto-error",
    path: "/ockto/:hash()/error",
    meta: errorEJUW_YqSUd2dWsYmb2CSw8oxOc_OUg4NI5tZOlRNmSMMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/error.vue")
  },
  {
    name: "ockto",
    path: "/ockto/:hash()",
    meta: indexgP3UFOSaXwVNokB6GPV2LHbcGqT2807J_5d7Ko_45e4IwMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/index.vue")
  },
  {
    name: "/investeringen.page-title",
    path: "/investeringen",
    meta: { ...(indexZF_45hzXm_n1QMWbJbOius6_32KZGXeQrQta4Lnp8TgfcMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/investeringen/index.vue")
  },
  {
    name: "ockto-qrcode",
    path: "/ockto/:hash()/qrcode",
    meta: { ...(qrcode1X3kcNZPy6Neuwg_ZbWy_KjGCU5M94GfJ3TCuyTy4ecMeta || {}), ...{"middleware":["qrcode"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/qrcode.vue")
  },
  {
    name: "ockto-success",
    path: "/ockto/:hash()/succes",
    meta: succes21H9Ea_eSmgZmA6j8CTCnMUXHdSglOzusXucMtTxUhwMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/ockto/[hash]/succes.vue")
  },
  {
    name: "onboarding-aanvraag",
    path: "/onboarding/aanvraag",
    meta: { ...(aanvraag6oDt_x3W_45Wvu3rpX_456WeSQrQwVTQmieE0c8ZqJAL_450UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/aanvraag.vue")
  },
  {
    name: "mijn-aanvragen",
    path: "/mijn-aanvragen",
    meta: { ...(index9UeF6qNZK_2KiPjDX_OyWqH6xsx08gXMSxv608DIs0EMeta || {}), ...{"middleware":["aanvragen"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-aanvragen/index.vue")
  },
  {
    name: "mogelijk-fonds",
    path: "/mogelijk-fonds",
    meta: { ...(indexOxZ7pVgAcLfkeojZnWSB1KOku8j_AqLN14hxlH666csMeta || {}), ...{"middleware":["auth","fund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/index.vue")
  },
  {
    name: "rentevoorstel-hash",
    path: "/rentevoorstel/:hash()",
    meta: _91hash_93kuB_sBRMJk432ULAgx_sccaSROEmZ9L_45eRoSdcUGXcYMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/rentevoorstel/[hash].vue")
  },
  {
    name: "verzekeringen-hash",
    path: "/verzekeringen/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/verzekeringen/[hash].vue")
  },
  {
    name: "Afspraak inplannen",
    path: "/afspraak/:hash()",
    meta: indexkkghDehtdqCKtaMYjrUs4cJjoTSqWKy3iDi_45Xc3VK6EMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/afspraak/[hash]/index.vue")
  },
  {
    name: "/feedback.page-title",
    path: "/feedback/:hash()",
    meta: indexCAiXGVCSEEemE0LbiuEXo1KTwZAryU1HzV4wmpaka78Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/feedback/[hash]/index.vue")
  },
  {
    name: "borrowerInvestment",
    path: "/hypotheken/:id()",
    meta: { ...(indexA3irFoClL80EIeNJYyufg0PGrPNfaPoELJEVdBChH2wMeta || {}), ...{"middleware":["auth","avborrower","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/hypotheken/[id]/index.vue")
  },
  {
    name: "claims-en-opties",
    path: "/claims-en-opties",
    meta: { ...(indexDJHqnrynt7fANN2roPWAYvDd6wn37SaN1KcfzJcehWAMeta || {}), ...{"middleware":["auth","investor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/claims-en-opties/index.vue")
  },
  {
    name: "loginResetPassword",
    path: "/login/reset-wachtwoord",
    meta: reset_45wachtwoordXnUNi_584dftXlZ0QIyhft_j_KIBKPxBQa_QjsUsneQMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/login/reset-wachtwoord.vue")
  },
  {
    name: "partnerplan",
    path: "/mijn-partnerplan",
    meta: { ...(index65drtMA_hGjHMVx1XmFrm5ISYM2XCj5h_8TcbAQlBV8Meta || {}), ...{"middleware":["auth","partnerplan"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-partnerplan/index.vue")
  },
  {
    name: "mijn-organisaties",
    path: "/mijn-organisaties",
    meta: { ...(index5AX_45bch5_45UEItFcjR3_4599y74MeARNg2AvzvdA5758EAMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-organisaties/index.vue")
  },
  {
    name: "investment",
    path: "/investeringen/:id()",
    meta: { ...(index0g72Aq9fgwbNHkHKu5nYNDIqEJdeFiPi_45mSPmuMwsvMMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/investeringen/[id]/index.vue")
  },
  {
    name: "privacy-verklaring",
    path: "/privacy-verklaring",
    meta: indexvEKi6T2eGeka3VkPjMyicp8oKkLauSjLqnGJpI_Lma8Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/privacy-verklaring/index.vue")
  },
  {
    name: "hypotheek",
    path: "/hypotheek-overzicht",
    meta: { ...(indexOfBgwnEanQrjvymHPYGKIL6LkdkMOv357nkMDM1rVLsMeta || {}), ...{"middleware":["auth","avborrower","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/hypotheek-overzicht/index.vue")
  },
  {
    name: "loginForgotPassword",
    path: "/login/wachtwoord-vergeten",
    meta: wachtwoord_45vergetenJEVDwRHcjIaJmBe1RKxDOL9xttJ46S68pJcP21xL0xsMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/login/wachtwoord-vergeten.vue")
  },
  {
    name: "mogelijk-fonds-id",
    path: "/mogelijk-fonds/:id()",
    meta: { ...(index95r4dhDM4FksnyyKW5kMsavt0vttW9O26BM1rNuuY_AMeta || {}), ...{"middleware":["auth","currentfund","fund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/index.vue")
  },
  {
    name: "financieel",
    path: "/financieel-overzicht",
    meta: { ...(indexyEIIhle5L948T1FsK5lcsHksaaEyH_45YFdwol_jzbOFIMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/financieel-overzicht/index.vue")
  },
  {
    name: "einde-looptijd-lening-hash",
    path: "/einde-looptijd-lening/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/einde-looptijd-lening/[hash].vue")
  },
  {
    name: "sso-exchangeToken-fundKey",
    path: "/sso/:exchangeToken()/:fundKey()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[exchangeToken]/[fundKey].vue")
  },
  {
    name: "mijn-profiel-naw-gegevens",
    path: "/mijn-profiel/naw-gegevens",
    meta: { ...(indexXyPtcMmdgU00M_wSDv3_45NdP573J9JOySC24vzfFBJzMMeta || {}), ...{"middleware":["auth","investor"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/naw-gegevens/index.vue")
  },
  {
    name: "onboarding-signing_id-token",
    path: "/onboarding/:signing_id()/:token()",
    meta: _91token_937Y4OtMVbIp7n37zGerfFyzth7vFq7gZXLVYUiuMoD5sMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/[signing_id]/[token].vue")
  },
  {
    name: "onboarding-bedankt-experience",
    path: "/onboarding/bedankt/:experience()",
    meta: { ...(_91experience_93ASjcrE8H6_viUi9q_45JJ4WPijjtb6UbdRyfLBxgYrSqkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/onboarding/bedankt/[experience].vue")
  },
  {
    name: "financieel-overzicht-rente",
    path: "/financieel-overzicht/rente",
    meta: { ...(index3QB4pyKtEC1X6znjHH1Qh_elYOhsDVTgBilJk5tJko4Meta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/financieel-overzicht/rente/index.vue")
  },
  {
    name: "mijn-profiel-iban-overzicht",
    path: "/mijn-profiel/iban-overzicht",
    meta: { ...(indexViZFAeztq0Il_451ebMujwKtC9ohVZwH5tplt2OAJDldcMeta || {}), ...{"middleware":["auth","investor"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/iban-overzicht/index.vue")
  },
  {
    name: "mijn-aanvragen-offerNumber",
    path: "/mijn-aanvragen/:offerNumber()",
    meta: indexNPDnIlC9ckPlvmZwiVy_45i8itPKw3gTufpRDLamreo_45EMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-aanvragen/[offerNumber]/index.vue")
  },
  {
    name: "mogelijk-fonds-id-deelname",
    path: "/mogelijk-fonds/:id()/deelname",
    meta: { ...(indexTfcv3ddizxUFHaUoiBB_ZpNfgwvDib4w9SMhInW6xf4Meta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/deelname/index.vue")
  },
  {
    name: "mogelijk-fonds-id-overmaken",
    path: "/mogelijk-fonds/:id()/overmaken",
    meta: { ...(indexcqzil15MDKR2CiTRF9JwSLGdX1rMv3dezW_45BfwnLheAMeta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/overmaken/index.vue")
  },
  {
    name: "/financieel-overzicht/financien.page-title",
    path: "/financieel-overzicht/financien",
    meta: { ...(indexciqzk_45Yo_7SujsjG6YJWJmmQ7bCVE2oN52XBZZ_y24oMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/financieel-overzicht/financien/index.vue")
  },
  {
    name: "mogelijk-fonds-id-documenten",
    path: "/mogelijk-fonds/:id()/documenten",
    meta: { ...(indexOtjefEugoDP3zrrxKJ5HerrqDSa3GqS9FRKinyC7o8EMeta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/documenten/index.vue")
  },
  {
    name: "sso-exchangeToken-onboarding",
    path: "/sso/:exchangeToken()/onboarding",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[exchangeToken]/onboarding/index.vue")
  },
  {
    name: "mogelijk-fonds-id-inschrijving",
    path: "/mogelijk-fonds/:id()/inschrijving",
    meta: { ...(indexuilgMJ9uiCGnch8rNmNHnbcjN3sqz45vqSUUZbDyvagMeta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/inschrijving/index.vue")
  },
  {
    name: "mogelijk-fonds-id-ondertekenen",
    path: "/mogelijk-fonds/:id()/ondertekenen",
    meta: { ...(indexCJUTB51XTDd8ZmBkmMLqTGDvWw4qSeNXMDoe39dF5UEMeta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mogelijk-fonds/[id]/ondertekenen/index.vue")
  },
  {
    name: "partnerplan-deel-gegevens",
    path: "/mijn-partnerplan/:token()/:choice()",
    meta: indexM_45K36VKiFvI91_45rlwCcAhnUcUMb1Wl2FeaFI4_45k4vZMMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-partnerplan/[token]/[choice]/index.vue")
  },
  {
    name: "sso-exchangeToken-onboarding-aanvraag",
    path: "/sso/:exchangeToken()/onboarding/aanvraag",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/sso/[exchangeToken]/onboarding/aanvraag.vue")
  },
  {
    name: "aanbod-optie-propertyId-hash-choice",
    path: "/aanbod-optie/:propertyId()/:hash()/:choice()",
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/aanbod-optie/[propertyId]/[hash]/[choice].vue")
  },
  {
    name: "mijn-organisaties-bedrijfs-gegevens",
    path: "/mijn-organisaties/bedrijfs-gegevens",
    meta: { ...(indexpOSyu6Pdf44emTo6XhNLxfpl_45CTZsDh49HnoZu8ZISwMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-organisaties/bedrijfs-gegevens/index.vue")
  },
  {
    name: "mijn-profiel-digitaal-identificeren",
    path: "/mijn-profiel/digitaal-identificeren",
    meta: { ...(indexSl2nwE_45Py0jtcI9dA0vCeB8ttkwgHLS69hL8Sv4S2joMeta || {}), ...{"middleware":["onfido"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-profiel/digitaal-identificeren/index.vue")
  },
  {
    name: "mijn-aanvragen-offerNumber-herkomst",
    path: "/mijn-aanvragen/:offerNumber()/herkomst",
    meta: indexg7MSwW9USkg2nxltiIz6AFy_Rwjjxixq2fFCUDlMDYkMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-aanvragen/[offerNumber]/herkomst/index.vue")
  },
  {
    name: "fonds-optie-property_id-hash-type",
    path: "/fonds-optie/:property_id()/:hash()/:type()",
    meta: indexilzQLt_vHYFmt1xJiguUoPSGiurMo0kXr5nzjDn_L8oMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/fonds-optie/[property_id]/[hash]/[type]/index.vue")
  },
  {
    name: "mijn-organisaties-companyId-iban-overzicht",
    path: "/mijn-organisaties/:companyId()/iban-overzicht",
    meta: { ...(indexIjpNBLEbRRgWoJIWDx_u1smQy3YsQ50H5V9PaCJ0LAoMeta || {}), ...{"middleware":["company"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250617054630/packages/investors/pages/mijn-organisaties/[companyId]/iban-overzicht/index.vue")
  }
]